import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";

function useDeleteAddendum() {
  return useAxiosMutation(["deleteAddendum"], (addendumId: string) =>
    axiosChartInstance.delete(`v1/addendum/${addendumId}`)
  );
}

export { useDeleteAddendum };
